import React, { useEffect, useState } from "react";
import useAutoExpandTextarea from "../../../../hooks/useAutoExpandTextarea";
import "./simpleTextarea.scss";

const TextArea = ({ label, errorRequire, defaultValue, onChange, ...rest }) => {
  const [isRequire, setIsRequire] = useState(false);
  const [touched, setTouched] = useState(false);
  const [currentValue, setCurrentValue] = useState( "");
  
  // Auto-expand textarea hook
  const textareaRef = useAutoExpandTextarea(currentValue, 21);

  const handleBlur = (evt) => {
    const { value, required } = evt.target;

    if (!touched) {
      setTouched(true);
    }

    if (required && !value.trim()) {
      setIsRequire(true);
    }
  };

  const handleFocus = () => {
    if (isRequire) {
      setIsRequire(false);
    }
  };

  const onChangeHandler = (e) => {
    setCurrentValue(e?.target?.value);
    if(onChange){
      onChange(e?.target?.value);
    }
  }

  useEffect( () => {
    setCurrentValue(defaultValue)
  }, [defaultValue])

  const textareaId = `textarea-${rest.name}`;
  const requireClasseName = isRequire && touched ? "errorRequire show" : "errorRequire";

  return (
    <>
      <div className="formField autoHeight">
        <div className="formFieldSimpleTextarea">
          <label className={requireClasseName} htmlFor={textareaId}>
            {errorRequire}
          </label>
          <textarea
            {...rest}
            ref={textareaRef}
            className="simpleTextarea"
            onChange={onChangeHandler}
            value={currentValue || ""}
            id={textareaId}
            onBlur={handleBlur}
            onFocus={handleFocus}
          />
          <label className="inputLabel" htmlFor={textareaId}>
            {rest.placeholder}
          </label>
        </div>
      </div>
    </>
  );
};

export default TextArea;
